import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, ScrollView, Platform } from 'react-native';
import { useNavigation, useFocusEffect } from '@react-navigation/native';
import { Ionicons } from '@expo/vector-icons';
import { ProfileCardEditor, PROFILE_CARD_EDITOR_BLUE } from '../components/ProfileCardEditor';

const ACCENT = '#fbcd9d';

export default function ProfileCardEdit() {
  const navigation = useNavigation();

  useFocusEffect(
    React.useCallback(() => {
      // ProfileCardEditor reloads from user doc on mount; focus ensures fresh state when returning.
    }, [])
  );

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity
          onPress={() => {
            if (navigation.canGoBack()) {
              navigation.goBack();
            } else {
              navigation.navigate('Profile');
            }
          }}
          style={styles.backBtn}
        >
          <Ionicons name="arrow-back" size={24} color={ACCENT} />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Edit profile card</Text>
      </View>

      <ScrollView style={styles.scroll} contentContainerStyle={styles.scrollContent}>
        <ProfileCardEditor
          onSaved={() => {
            if (navigation.canGoBack()) {
              navigation.goBack();
            } else {
              navigation.navigate('Profile');
            }
          }}
        />
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: PROFILE_CARD_EDITOR_BLUE,
    paddingTop: Platform.OS === 'web' ? 80 : 70,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  backBtn: {
    padding: 8,
    marginRight: 8,
  },
  headerTitle: {
    fontFamily: 'Glacial Indifference',
    fontSize: 20,
    fontWeight: '600',
    color: ACCENT,
    flex: 1,
  },
  scroll: {
    flex: 1,
  },
  scrollContent: {
    paddingHorizontal: 20,
    paddingBottom: 40,
  },
});
